import {
    Button,
    IconButton,
    Modal,
    TextareaAutosize
} from '@mui/material';
import {
    Close,
    Edit
} from '@mui/icons-material';
import {  Dropdown } from "antd";
import Loading from "components/Loading";
import React, { useState } from "react";
import {
    handleTranscriptEdit
} from "store/interactions/thunks";
import styled from "styled-components";
import COLOR from "utils/constants/color";
import * as Sentry from '@sentry/react';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';

const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  @media only screen and (max-width: 600px) {
    min-width: 90% !important;
  }
`;

const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;

const TitleTextCover = styled.span`
  font-size: 14px;
  color: black;
  font-weight: 600;
  // margin-left:5px;
  // margin-top:5px;
`;
const TextAreaAuto = styled(TextareaAutosize)`
    height: 350px;
    width: 100%;
    border-radius: 2px;
    padding: 5px;
    overflow: scroll;
    border-color: rgb(0 0 0 / 32%);
    ::focus-visible {
      outline: ${COLOR.green100}auto 1px !important;
     }
    ::focus{
      border-color: ${COLOR.green100} !important;
  }
`;



const getTrack = async (url) => {
  const fetchVtt = async () => {
    try {
      const cacheBuster = `?v=${Date.now()}`;  // Unique timestamp for each request
      const response = await fetch(`${url}${url.includes('?') ? '&' : '?'}${cacheBuster}`, {
        cache: "reload" // Ensures browser revalidates the content
      });
      return await response.text();
    } catch (error) {
    Sentry.captureException(`304 Error fetching VTT: ${error}`);
      console.error('Failed to load subtitles:', error);
      return '';
    }
  };
  return fetchVtt();
};
export const EditTranscript = ({ url , enSrt }) => {
    const showAlert = useAlert();
    const [transcript, setTranscript] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setMessage] = useState("");
    const [openEdit, setOpenEdit] = useState({
        open:false,
        update:""
    })

    const downloadVttForSpanish = async () => {
        try {
            setLoading(true)
            const track_text = await getTrack(url)
            if (typeof track_text === "string") {
                setTranscript(track_text)
            }
        } catch (error) {
            Sentry.captureException(`305 Error fetching VTT: ${error}`);
        } finally {
            setLoading(false)
        }
    };
    const downloadVttforEng = async () => {
        try {
            setLoading(true)
            const track_text = await getTrack(enSrt)
            if (typeof track_text === "string") {
                setTranscript(track_text)
            }
        } catch (error) {
            Sentry.captureException(`306 Error fetching VTT: ${error}`);
        } finally {
            setLoading(false)
        }
    };

    const handleSave = async () => {
        setLoading(true);
        setError(false);
        setMessage("");
        try {
            const response = await handleTranscriptEdit({
                url: openEdit.update == "spanish" ? url : enSrt,
                transcript,
            });
            if (response.success) {
                setOpenEdit({
                    open: false
                });
                showAlert(`Updated successfully!`,"success")
            } else {
                showAlert(`Something went wrong!`,"error")
            }
        } catch (error) {
            Sentry.captureException(`307 Error saving transcript: ${error}`);
            setError(true);
            setMessage(error?.message);
        }
        setLoading(false);
    };
    if (!url) return null;
    return (
        <div>
            {url && enSrt ? (
                <Dropdown
                    menu={{
                        items: [
                            {
                                key: 'spanish',
                                label: 'Spanish',
                                onClick: () => {
                                    downloadVttForSpanish();
                                    setOpenEdit({
                                        open: true,
                                        update: "spanish",
                                    });
                                }
                            },
                            {
                                key: 'english',
                                label: 'English',
                                onClick: () => {
                                    downloadVttforEng();
                                    setOpenEdit({
                                        open: true,
                                        update: "english",
                                    });
                                }
                            }
                        ]
                    }}
                    trigger={["click"]}
                >
                    <Button>
                        <Edit />
                    </Button>
                </Dropdown>
            ) : (
                <Button
                    onClick={() => {
                        downloadVttForSpanish();
                        setOpenEdit({
                            open: true,
                            update: "spanish",
                        });
                    }}
                >
                    <Edit />
                </Button>
            )}
           
            <Modal
                open={openEdit.open}
                onClose={() => {  setOpenEdit({open:false }); }}
                style={{ height: "100%", width: "100%" }}>
                <ModalContent>
                    <TitleTextCover>Edit Transcript</TitleTextCover>
                    <IconButton onClick={() => { setOpenEdit({open:false }) }} style={{ padding: 0, position: "absolute", right: 0, top: 0 }}>
                        <Close color="secondary" />
                    </IconButton>
                    {loading && <Loading />}
                    <ModalConfigArea className='editModalTxtArea'>
                        <TextAreaAuto
                            id="Transcript"
                            name="Transcript"
                            label="Transcript"
                            InputLabelProps={{ shrink: true, required: true }}
                            type="text"
                            variant="outlined"
                            margin="normal"
                            onChange={(e) => setTranscript(e.target.value)}
                            value={transcript}
                            maxRows={4}
                            style={{ maxHeight: "50vh", minHeight: "350px", overflow: "scroll" }}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSave}
                            disabled={loading}
                        >
                            {loading ? "Saving..." : "Save"}
                        </Button>
                        {error && <p style={{ color: "red" }}>{errorMessage}</p>}
                    </ModalConfigArea>
                </ModalContent>
            </Modal>

        </div>
    );



}